@layer components {
  .errorState {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: var(--spacing-8);
    gap: var(--spacing-4);
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
    user-select: none;
    -webkit-user-select: none;
  }

  .errorState[data-variant='page'] {
    min-height: 400px;
    height: 100%;
  }

  .errorState[data-variant='section'] {
    padding: var(--spacing-4);
    min-height: auto;
  }

  .icon {
    color: var(--text-error);
    flex-shrink: 0;
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-2);
  }

  .title {
    font-size: var(--text-xl);
    font-weight: var(--font-weight-semibold);
    color: var(--text-primary);
  }

  .description {
    font-size: var(--text-lg);
    color: var(--text-secondary);
    line-height: var(--leading-relaxed);
  }

  .actions {
    display: flex;
    align-items: center;
    gap: var(--spacing-3);
    margin-top: var(--spacing-3);
  }
}
